const ID_TOKEN_KEY = "id_token" as string;
const ID_COMPANY_KEY = "id_company" as string;

/**
 * @description get token form localStorage
 */
export const getToken = (): string | null => {
  return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const getCompany = (): string | null => {
  return window.localStorage.getItem(ID_COMPANY_KEY);
};

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveToken = (token: string): void => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const saveCompany = (token: string): void => {
  window.localStorage.setItem(ID_COMPANY_KEY, token);
}

/**
 * @description remove token form localStorage
 */
export const destroyToken = (): void => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
  window.localStorage.removeItem(ID_COMPANY_KEY);
};

export default { getToken, getCompany,  saveToken, saveCompany, destroyToken };
